import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.reduce.js";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
export { Link } from 'gatsby';

if (typeof Link !== 'undefined' && Link && Link === Object(Link) && Object.isExtensible(Link) && !Link.hasOwnProperty('__filemeta')) {
  Object.defineProperty(Link, '__filemeta', {
    configurable: true,
    value: {
      name: "Link",
      filename: "node_modules/docz/dist/index.esm.js"
    }
  });
}

import { createContext, createElement, useContext, Fragment, Component, useMemo, useEffect, useRef, useState, memo } from 'react';
import _merge from 'lodash/fp/merge';
import equal from 'fast-deep-equal';
import _kebabCase from 'lodash/fp/kebabCase';
import _mapValues from 'lodash/fp/mapValues';
import _get from 'lodash/fp/get';
import _first from 'lodash/fp/first';
import _assoc from 'lodash/fp/assoc';
import { pascalCase } from 'pascal-case';
import marksy from 'marksy';
import sort from 'array-sort';
import _unionBy from 'lodash/fp/unionBy';
import _flattenDepth from 'lodash/fp/flattenDepth';
import _omit from 'lodash/fp/omit';
import _pipe from 'lodash/fp/pipe';
import { ulid } from 'ulid';
import match from 'match-sorter';
import _throttle from 'lodash/fp/throttle';
import { __rest } from 'tslib';
import capitalize from 'capitalize';

var DefNotFound = function DefNotFound() {
  return /*#__PURE__*/createElement(Fragment, null, "Not found");
};

var DefLayout = function DefLayout(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/createElement(Fragment, null, children);
};

var DefPlayground = function DefPlayground(_ref2) {
  var component = _ref2.component,
      code = _ref2.code;
  return /*#__PURE__*/createElement("div", null, component, /*#__PURE__*/createElement("pre", null, code));
};

var defaultComponents = {
  layout: DefLayout,
  notFound: DefNotFound,
  playground: DefPlayground
};
var ctx = /*#__PURE__*/createContext(defaultComponents);

var ComponentsProvider = function ComponentsProvider(_ref3) {
  var _ref3$components = _ref3.components,
      themeComponents = _ref3$components === void 0 ? {} : _ref3$components,
      children = _ref3.children;
  return /*#__PURE__*/createElement(ctx.Provider, {
    value: Object.assign({}, defaultComponents, themeComponents)
  }, children);
};

var useComponents = function useComponents() {
  return useContext(ctx);
};

function create(initial) {
  var _a;

  var ctx = /*#__PURE__*/createContext(initial);
  var listeners = new Set();

  var dispatch = function dispatch(fn) {
    listeners.forEach(function (listener) {
      return listener(fn);
    });
  };

  return {
    context: ctx,
    set: function set(fn) {
      return dispatch(fn);
    },
    Provider: (_a = /*#__PURE__*/function (_Component) {
      _inheritsLoose(Provider, _Component);

      function Provider() {
        var _this;

        _this = _Component.apply(this, arguments) || this;
        _this.state = _this.props.initial || initial || {};
        return _this;
      }

      Provider.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
        if (!equal(props.initial, state)) return props.initial;
        return null;
      };

      var _proto = Provider.prototype;

      _proto.componentDidMount = function componentDidMount() {
        var _this2 = this;

        listeners.add(function (fn) {
          return _this2.setState(fn);
        });
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        listeners.clear();
      };

      _proto.render = function render() {
        return /*#__PURE__*/createElement(ctx.Provider, {
          value: this.state
        }, this.props.children);
      };

      return Provider;
    }(Component), _a.displayName = 'DoczStateProvider', _a)
  };
}

var doczState = create({});

var useConfig = function useConfig() {
  var state = useContext(doczState.context);
  var transform = state.transform,
      config = state.config,
      _state$themeConfig = state.themeConfig,
      themeConfig = _state$themeConfig === void 0 ? {} : _state$themeConfig;

  var newConfig = _merge(themeConfig, config ? config.themeConfig : {});

  var transformed = transform ? transform(newConfig) : newConfig;
  return Object.assign({}, config, {
    themeConfig: transformed
  });
};

var useComponentProps = function useComponentProps(_ref4) {
  var componentName = _ref4.componentName,
      fileName = _ref4.fileName;
  var components = useComponents();

  var _useContext = useContext(doczState.context),
      stateProps = _useContext.props;

  var componentMatcher = function componentMatcher(componentName, item) {
    var matchingPatterns = [fileName, "/" + componentName + ".", "/" + _kebabCase(componentName) + ".", "/" + pascalCase(componentName) + "."];
    return !!matchingPatterns.find(function (pattern) {
      return item.key.includes(pattern);
    });
  };

  var found = stateProps && stateProps.length > 0 && stateProps.find(function (item) {
    return componentMatcher(componentName, item);
  });
  var value = _get('value', found) || [];

  var firstDefinition = _first(value);

  var definition = value.find(function (i) {
    return i.displayName === componentName;
  });
  var compile = useMemo(function () {
    return marksy({
      createElement: createElement,
      elements: components
    });
  }, [components]);
  var props = useMemo(function () {
    var props = _get('props', definition || firstDefinition);

    var parseDescs = _mapValues(function (prop) {
      var desc = _get('description', prop);

      return !desc ? prop : _assoc('description', compile(desc).tree, prop);
    });

    return parseDescs(props);
  }, [compile, definition || firstDefinition]);
  return props;
};

var useCurrentDoc = function useCurrentDoc() {
  var state = useContext(doczState.context);
  return _get('currentEntry.value', state);
};

var updateState = function updateState(ev) {
  var _JSON$parse = JSON.parse(ev.data),
      type = _JSON$parse.type,
      payload = _JSON$parse.payload;

  var prop = type.startsWith('state.') && type.split('.')[1];

  if (prop) {
    doczState.set(function (state) {
      var _Object$assign;

      return Object.assign({}, state, (_Object$assign = {}, _Object$assign[prop] = payload, _Object$assign));
    });
  }
};

var useDataServer = function useDataServer(url) {
  useEffect(function () {
    if (!url) return;
    var socket = new WebSocket(url);
    socket.onmessage = updateState;
    return function () {
      return socket.close();
    };
  }, []);
};

function flatArrFromObject(arr, prop) {
  var reducer = function reducer(arr, obj) {
    var value = _get(prop)(obj);

    return value ? arr.concat([value]) : arr;
  };

  return Array.from(new Set(arr.reduce(reducer, [])));
}

function compare(a, b, reverse) {
  if (a < b) return reverse ? 1 : -1;
  if (a > b) return reverse ? -1 : 1;
  return 0;
}

var useDocs = function useDocs() {
  var _useContext2 = useContext(doczState.context),
      _useContext2$entries = _useContext2.entries,
      entries = _useContext2$entries === void 0 ? [] : _useContext2$entries;

  var arr = entries.map(function (_ref5) {
    var value = _ref5.value;
    return value;
  });
  return sort(arr, function (a, b) {
    return compare(a.name, b.name);
  });
};

var noMenu = function noMenu(entry) {
  return !entry.menu;
};

var fromMenu = function fromMenu(menu) {
  return function (entry) {
    return entry.menu === menu;
  };
};

var entriesOfMenu = function entriesOfMenu(menu, entries) {
  return entries.filter(fromMenu(menu));
};

var parseMenu = function parseMenu(entries) {
  return function (name) {
    return {
      name: name,
      menu: entriesOfMenu(name, entries)
    };
  };
};

var menusFromEntries = function menusFromEntries(entries) {
  var entriesWithoutMenu = entries.filter(noMenu);
  var menus = flatArrFromObject(entries, 'menu').map(parseMenu(entries));
  return _unionBy('name', menus, entriesWithoutMenu);
};

var parseItemStr = function parseItemStr(item) {
  return typeof item === 'string' ? {
    name: item
  } : item;
};

var normalize = function normalize(item) {
  var selected = parseItemStr(item);
  return Object.assign({}, selected, {
    id: selected.id || ulid(),
    parent: _get('parent', selected) || _get('parent', item),
    menu: Array.isArray(selected.menu) ? selected.menu.map(normalize) : selected.menu
  });
};

var clean = function clean(item) {
  return item.href || item.route ? _omit('menu', item) : item;
};

var normalizeAndClean = _pipe(normalize, clean);

var mergeMenus = function mergeMenus(entriesMenu, configMenu) {
  var first = entriesMenu.map(normalizeAndClean);
  var second = configMenu.map(normalizeAndClean);

  var merged = _unionBy('name', first, second);

  return merged.map(function (item) {
    if (!item.menu) return item;
    var found = second.find(function (i) {
      return i.name === item.name;
    });
    var foundMenu = found && found.menu;
    return Object.assign({}, item, {
      menu: foundMenu ? mergeMenus(item.menu, foundMenu) : item.menu || found.menu
    });
  });
};

var UNKNOWN_POS = Infinity;

var findPos = function findPos(item, orderedList) {
  if (orderedList === void 0) {
    orderedList = [];
  }

  var name = typeof item !== 'string' ? _get('name', item) : item;
  var pos = orderedList.findIndex(function (item) {
    return item === name;
  });
  return pos !== -1 ? pos : UNKNOWN_POS;
};

var compareWithMenu = function compareWithMenu(to) {
  if (to === void 0) {
    to = [];
  }

  return function (a, b) {
    var list = to.map(function (i) {
      return i.name || i;
    });
    return compare(findPos(a, list), findPos(b, list));
  };
};

var sortByName = function sortByName(a, b) {
  return a.name < b.name ? -1 : a.name > b.name ? 1 : 0;
};

var sortMenus = function sortMenus(first, second) {
  if (second === void 0) {
    second = [];
  }

  var sorted = sort(first, compareWithMenu(second), sortByName);
  return sorted.map(function (item) {
    if (!item.menu) return item;
    var found = second.find(function (menu) {
      return menu.name === item.name;
    });
    var foundMenu = found && found.menu;
    return Object.assign({}, item, {
      menu: foundMenu ? sortMenus(item.menu, foundMenu) : sort(item.menu, sortByName)
    });
  });
};

var search = function search(val, menu) {
  var items = menu.map(function (item) {
    return [item].concat(item.menu || []);
  });

  var flattened = _flattenDepth(2, items);

  var flattenedDeduplicated = Array.from(new Set(flattened));
  return match(flattenedDeduplicated, val, {
    keys: ['name']
  });
};

var filterMenus = function filterMenus(items, filter) {
  if (!filter) return items;
  return items.filter(filter).map(function (item) {
    if (!item.menu) return item;
    return Object.assign({}, item, {
      menu: item.menu.filter(filter)
    });
  });
};

var useMenus = function useMenus(opts) {
  var _ref6 = opts || {},
      _ref6$query = _ref6.query,
      query = _ref6$query === void 0 ? '' : _ref6$query;

  var _useContext3 = useContext(doczState.context),
      entries = _useContext3.entries,
      config = _useContext3.config;

  if (!entries) return null;
  var arr = entries.map(function (_ref7) {
    var value = _ref7.value;
    return value;
  });
  var entriesMenu = menusFromEntries(arr);
  var sorted = useMemo(function () {
    var merged = mergeMenus(entriesMenu, config.menu);
    var result = sortMenus(merged, config.menu);
    return filterMenus(result, opts && opts.filter);
  }, [entries, config]);
  return query && query.length > 0 ? search(query, sorted) : sorted;
};

var usePrevious = function usePrevious(value, defaultValue) {
  var ref = useRef(defaultValue);
  useEffect(function () {
    ref.current = value;
  });
  return ref.current;
};

var isClient = typeof window === 'object';

var getSize = function getSize(initialWidth, initialHeight) {
  return {
    innerHeight: isClient ? window.innerHeight : initialHeight,
    innerWidth: isClient ? window.innerWidth : initialWidth,
    outerHeight: isClient ? window.outerHeight : initialHeight,
    outerWidth: isClient ? window.outerWidth : initialWidth
  };
};

var useWindowSize = function useWindowSize(throttleMs, _initialWidth, initialHeight) {
  if (throttleMs === void 0) {
    throttleMs = 300;
  }

  if (_initialWidth === void 0) {
    _initialWidth = Infinity;
  }

  if (initialHeight === void 0) {
    initialHeight = Infinity;
  }

  var _useState = useState(getSize(initialHeight, initialHeight)),
      windowSize = _useState[0],
      setWindowSize = _useState[1];

  var tSetWindowResize = _throttle(throttleMs, function () {
    return setWindowSize(getSize(initialHeight, initialHeight));
  });

  useEffect(function () {
    window.addEventListener('resize', tSetWindowResize);
    return function () {
      return void window.removeEventListener('resize', tSetWindowResize);
    };
  }, []);
  return windowSize;
};

var Playground = function Playground(_ref8) {
  var className = _ref8.className,
      children = _ref8.children,
      style = _ref8.style,
      wrapper = _ref8.wrapper,
      __scope = _ref8.__scope,
      __position = _ref8.__position,
      __code = _ref8.__code,
      language = _ref8.language,
      useScoping = _ref8.useScoping;
  var components = useComponents();
  var PlaygroundComponent = components.playground;
  if (!PlaygroundComponent) return null;
  return /*#__PURE__*/createElement(PlaygroundComponent, {
    components: components,
    component: children,
    className: className,
    style: style,
    wrapper: wrapper,
    scope: __scope,
    position: __position,
    code: __code,
    language: language,
    useScoping: useScoping
  });
};

var RE_OBJECTOF = /(?:React\.)?(?:PropTypes\.)?objectOf\((?:React\.)?(?:PropTypes\.)?(\w+)\)/;

var getTypeStr = function getTypeStr(type) {
  switch (type.name.toLowerCase()) {
    case 'instanceof':
      return "Class(" + type.value + ")";

    case 'enum':
      if (type.computed) return type.value;
      return type.value ? type.value.map(function (v) {
        return "" + v.value;
      }).join(' │ ') : type.raw;

    case 'union':
      return type.value ? type.value.map(function (t) {
        return "" + getTypeStr(t);
      }).join(' │ ') : type.raw;

    case 'array':
      return type.raw;

    case 'arrayof':
      return "Array<" + getTypeStr(type.value) + ">";

    case 'custom':
      if (type.raw.indexOf('function') !== -1 || type.raw.indexOf('=>') !== -1) return 'Custom(Function)';else if (type.raw.toLowerCase().indexOf('objectof') !== -1) {
        var m = type.raw.match(RE_OBJECTOF);
        if (m && m[1]) return "ObjectOf(" + capitalize(m[1]) + ")";
        return 'ObjectOf';
      }
      return 'Custom';

    case 'bool':
      return 'Boolean';

    case 'func':
      return 'Function';

    case 'shape':
      var shape = type.value;
      var rst = {};
      Object.keys(shape).forEach(function (key) {
        rst[key] = getTypeStr(shape[key]);
      });
      return JSON.stringify(rst, null, 2);

    default:
      return type.name;
  }
};

var humanize = function humanize(type) {
  return getTypeStr(type);
};

var getPropType = function getPropType(prop) {
  var propName = _get('name', prop.flowType || prop.type);

  if (!propName) return null;
  var isEnum = propName.startsWith('"') || propName === 'enum';
  var name = isEnum ? 'enum' : propName;

  var value = _get('type.value', prop);

  if (!name) return null;

  if (isEnum && typeof value === 'string' || !prop.flowType && !isEnum && !value || prop.flowType && !prop.flowType.elements) {
    return name;
  }

  return prop.flowType ? humanize(prop.flowType) : humanize(prop.type);
};

var Props = function Props(_a) {
  var title = _a.title,
      isToggle = _a.isToggle,
      isRaw = _a.isRaw,
      component = _a.of,
      rest = __rest(_a, ["title", "isToggle", "isRaw", "of"]);

  var components = useComponents();
  var PropsComponent = components.props;

  var fileName = _get('__filemeta.filename', component);

  var filemetaName = _get('__filemeta.name', component);

  var componentName = filemetaName || _get('displayName', component) || _get('name', component);

  var props = useComponentProps({
    componentName: componentName,
    fileName: fileName
  });
  if (!PropsComponent) return null;
  return /*#__PURE__*/createElement(PropsComponent, Object.assign({
    title: title,
    isRaw: isRaw,
    isToggle: isToggle,
    props: props,
    getPropType: getPropType,
    of: component
  }, rest));
};

function theme(themeConfig, transform) {
  if (transform === void 0) {
    transform = function transform(c) {
      return c;
    };
  }

  return function (WrappedComponent) {
    var Theme = /*#__PURE__*/memo(function (props) {
      var db = props.db,
          currentEntry = props.currentEntry,
          children = props.children;
      var initial = Object.assign({}, db, {
        currentEntry: currentEntry,
        themeConfig: themeConfig,
        transform: transform
      });
      return /*#__PURE__*/createElement(doczState.Provider, {
        initial: initial
      }, /*#__PURE__*/createElement(WrappedComponent, null, children));
    });
    Theme.displayName = WrappedComponent.displayName || 'DoczTheme';
    return Theme;
  };
}

export { ComponentsProvider, Playground, Props, doczState, theme, useComponentProps, useComponents, useConfig, useCurrentDoc, useDataServer, useDocs, useMenus, usePrevious, useWindowSize };

if (typeof useWindowSize !== 'undefined' && useWindowSize && useWindowSize === Object(useWindowSize) && Object.isExtensible(useWindowSize) && !useWindowSize.hasOwnProperty('__filemeta')) {
  Object.defineProperty(useWindowSize, '__filemeta', {
    configurable: true,
    value: {
      name: "useWindowSize",
      filename: "node_modules/docz/dist/index.esm.js"
    }
  });
}

if (typeof usePrevious !== 'undefined' && usePrevious && usePrevious === Object(usePrevious) && Object.isExtensible(usePrevious) && !usePrevious.hasOwnProperty('__filemeta')) {
  Object.defineProperty(usePrevious, '__filemeta', {
    configurable: true,
    value: {
      name: "usePrevious",
      filename: "node_modules/docz/dist/index.esm.js"
    }
  });
}

if (typeof useMenus !== 'undefined' && useMenus && useMenus === Object(useMenus) && Object.isExtensible(useMenus) && !useMenus.hasOwnProperty('__filemeta')) {
  Object.defineProperty(useMenus, '__filemeta', {
    configurable: true,
    value: {
      name: "useMenus",
      filename: "node_modules/docz/dist/index.esm.js"
    }
  });
}

if (typeof useDocs !== 'undefined' && useDocs && useDocs === Object(useDocs) && Object.isExtensible(useDocs) && !useDocs.hasOwnProperty('__filemeta')) {
  Object.defineProperty(useDocs, '__filemeta', {
    configurable: true,
    value: {
      name: "useDocs",
      filename: "node_modules/docz/dist/index.esm.js"
    }
  });
}

if (typeof useDataServer !== 'undefined' && useDataServer && useDataServer === Object(useDataServer) && Object.isExtensible(useDataServer) && !useDataServer.hasOwnProperty('__filemeta')) {
  Object.defineProperty(useDataServer, '__filemeta', {
    configurable: true,
    value: {
      name: "useDataServer",
      filename: "node_modules/docz/dist/index.esm.js"
    }
  });
}

if (typeof useCurrentDoc !== 'undefined' && useCurrentDoc && useCurrentDoc === Object(useCurrentDoc) && Object.isExtensible(useCurrentDoc) && !useCurrentDoc.hasOwnProperty('__filemeta')) {
  Object.defineProperty(useCurrentDoc, '__filemeta', {
    configurable: true,
    value: {
      name: "useCurrentDoc",
      filename: "node_modules/docz/dist/index.esm.js"
    }
  });
}

if (typeof useConfig !== 'undefined' && useConfig && useConfig === Object(useConfig) && Object.isExtensible(useConfig) && !useConfig.hasOwnProperty('__filemeta')) {
  Object.defineProperty(useConfig, '__filemeta', {
    configurable: true,
    value: {
      name: "useConfig",
      filename: "node_modules/docz/dist/index.esm.js"
    }
  });
}

if (typeof useComponents !== 'undefined' && useComponents && useComponents === Object(useComponents) && Object.isExtensible(useComponents) && !useComponents.hasOwnProperty('__filemeta')) {
  Object.defineProperty(useComponents, '__filemeta', {
    configurable: true,
    value: {
      name: "useComponents",
      filename: "node_modules/docz/dist/index.esm.js"
    }
  });
}

if (typeof useComponentProps !== 'undefined' && useComponentProps && useComponentProps === Object(useComponentProps) && Object.isExtensible(useComponentProps) && !useComponentProps.hasOwnProperty('__filemeta')) {
  Object.defineProperty(useComponentProps, '__filemeta', {
    configurable: true,
    value: {
      name: "useComponentProps",
      filename: "node_modules/docz/dist/index.esm.js"
    }
  });
}

if (typeof theme !== 'undefined' && theme && theme === Object(theme) && Object.isExtensible(theme) && !theme.hasOwnProperty('__filemeta')) {
  Object.defineProperty(theme, '__filemeta', {
    configurable: true,
    value: {
      name: "theme",
      filename: "node_modules/docz/dist/index.esm.js"
    }
  });
}

if (typeof doczState !== 'undefined' && doczState && doczState === Object(doczState) && Object.isExtensible(doczState) && !doczState.hasOwnProperty('__filemeta')) {
  Object.defineProperty(doczState, '__filemeta', {
    configurable: true,
    value: {
      name: "doczState",
      filename: "node_modules/docz/dist/index.esm.js"
    }
  });
}

if (typeof Props !== 'undefined' && Props && Props === Object(Props) && Object.isExtensible(Props) && !Props.hasOwnProperty('__filemeta')) {
  Object.defineProperty(Props, '__filemeta', {
    configurable: true,
    value: {
      name: "Props",
      filename: "node_modules/docz/dist/index.esm.js"
    }
  });
}

if (typeof Playground !== 'undefined' && Playground && Playground === Object(Playground) && Object.isExtensible(Playground) && !Playground.hasOwnProperty('__filemeta')) {
  Object.defineProperty(Playground, '__filemeta', {
    configurable: true,
    value: {
      name: "Playground",
      filename: "node_modules/docz/dist/index.esm.js"
    }
  });
}

if (typeof ComponentsProvider !== 'undefined' && ComponentsProvider && ComponentsProvider === Object(ComponentsProvider) && Object.isExtensible(ComponentsProvider) && !ComponentsProvider.hasOwnProperty('__filemeta')) {
  Object.defineProperty(ComponentsProvider, '__filemeta', {
    configurable: true,
    value: {
      name: "ComponentsProvider",
      filename: "node_modules/docz/dist/index.esm.js"
    }
  });
}